export const sectionActionType = {
  addField: "AddField",
  addFieldList: "AddFieldList",
  addFieldInfoToField: "AddFieldInfoToField",
  removeField: "RemoveField",
};
